import React from "react";
import { connect } from "react-redux";
import "./ArticleEditImageArrListItem.css";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ImageArrList from "../ImageArrList/ImageArrList";
import {
  snapShotEditArticleContentAction,
  recoverLastEditArticleContentAction,
  updateArticleContentTextAction,
  saveArticleAction
} from "../../redux/actions/editArticlePanel";
import SelectableEditText from "../SelectableEditText/SelectableEditText";

class ArticleEditImageArrListItem extends React.Component {
  constructor(props) {
    super(props);

    this.focus = this.focus.bind(this);
    this.blur = this.blur.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
  }

  onTextChange(event) {
    const {
      item,
      updateArticleContentTextAction,
      saveArticleAction,
      articleID
    } = this.props;

    updateArticleContentTextAction({ id: item.id, text: event.target.value });
    saveArticleAction(articleID);
  }

  focus() {
    const { item, snapShotEditArticleContentAction } = this.props;
    this.text = item.text;

    snapShotEditArticleContentAction();
  }

  blur() {
    const { item, recoverLastEditArticleContentAction } = this.props;

    if (this.text === item.text) {
      recoverLastEditArticleContentAction();
    }

    this.text = null;
  }

  render() {
    const { item, getPanelPosition, getCardTop, articleID } = this.props;

    return (
      <Card.Body style={{ paddingTop: "0", paddingBottom: "0" }}>
        <Row>
          <Col style={{ padding: "5px" }}>
            <ImageArrList
              articleID={articleID}
              getPanelPosition={getPanelPosition}
              getCardTop={getCardTop}
              item={item}
            />
          </Col>
        </Row>
        <Row>
          <Col style={{ padding: "5px" }}>
            <SelectableEditText
              onFocus={this.focus}
              //onBlur={this.blur}
              value={item.text}
              onChange={this.onTextChange}
            />
          </Col>
        </Row>
      </Card.Body>
    );
  }
}

const mapDispatch = {
  snapShotEditArticleContentAction,
  recoverLastEditArticleContentAction,
  updateArticleContentTextAction,
  saveArticleAction
};

export default connect(
  null,
  mapDispatch
)(ArticleEditImageArrListItem);
